export const UnavailableImageNames = {
  LARGE_IMG: '/UnavailableLarge.png',
  SMALL_IMG: '/UnavailableSmall.png'
}
